import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Layout } from './components/Layout';
//import { Home } from './components/Home';
//import { FetchData } from './components/FetchData';
//import { Counter } from './components/Counter';

import { SignInPage } from './pages/SignInPage';
import { CreateProjectPage } from './pages/CreateProjectPage';
import { ProjectTable } from './pages/ProjectTable';
import { MissionTable } from './pages/MissionTable';
import { ProjectDetailsPage } from './pages/ProjectDetailsPage';
import { CycleOfTheReportPage } from './pages/CycleOfTheReportPage';
import { CreateMissionPage } from './pages/CreateMissionPage';
import { CreateMissionPageAuthorized } from './pages/CreateMissionPageAuthorized';
import { CycleOfTheReport2Page } from './pages/CycleOfTheReport2Page';
//import { DashboardPage } from './pages/DashboardPage';
import { AssignMissionPage } from './pages/AssignMissionPage';
import { UploadFilePage } from './pages/UploadFilePage';
import { E_MonitoringNoteSupply } from './pages/E_MonitoringNoteSupply';
import { E_Mq } from './pages/E_Mq';
import { E_MonitoringNoteWorks } from './pages/E_MonitoringNoteWorks';
import { E_Mr } from './pages/E_Mr';
import { O_MonitoringNoteSupplies } from './pages/O_MonitoringNoteSupplies';
import { O_MonitoringNoteWorks } from './pages/O_MonitoringNoteWorks';
import { O_Mr } from './pages/O_Mr';
import { O_Mq } from './pages/O_Mq';
import { Provider } from 'mobx-react';
import { stores } from './store';
import { TemplateFillingPage } from './pages/TemplateFillingPage';
import { SearchFilter } from './pages/SearchFilter';
import { MissionDetailsPage } from './pages/MissionDetailsPage';
import { UsersPage } from './pages/UsersPage';
import { PasswordReset } from './pages/PasswordReset';
import { ContactListPage } from './pages/ContactListPage';
import { ChangePasswordPage } from './pages/ChangePasswordPage';
import { ListofAllProjects } from './pages/ListofAllProjects';
import { ThematicReport } from './pages/ThematicReport';
import { HelpPage } from './pages/HelpPage';
import { ForgotPassword } from './pages/ForgotPassword';
import { DefinitionsBeneficiariesPage } from './pages/DefinitionsBeneficiariesPage';
import { EntryIntervention } from './pages/EntryIntervention';

global.variables = {
    API_REVISION_SUBMITREVISIONTODATABASE: '/api/Revision/SubmitRevisionToDatabase',
    API_REVISION_GETPOSSIBLEREVISIONS: '/api/Revision/GetPossibleRevisions',
    API_CREATEPROJECT: '/api/CreateProject/SubmitPage',
    API_CREATEPROJECT_LOADPAGE: '/api/CreateProject/LoadPage',
    API_UPDATEPROJECT: '/api/CreateProject/UpdateProject',
    API_CREATEMISSION: '/api/CreateProject/CreateMission',
    API_CREATEMISSION_LOADPAGE: '/api/CreateProject/LoadPage',
    API_UPDATEMISSION: '/api/CreateProject/UpdateMission',
    API_EMONITORINGNOTESUPPLY_LOADPAGEJSON: '/api/EMonitoringNoteSupply/LoadPageJSON',
    API_EMONITORINGNOTESUPPLY_SUBMITPAGEJSON: '/api/EMonitoringNoteSupply/SubmitPageJSON',
    API_EMONITORINGNOTEWORKS_LOADPAGEJSON: '/api/EMonitoringNoteWorks/LoadPageJSON',
    API_EMONITORINGNOTEWORKS_SUBMITPAGEJSON: '/api/EMonitoringNoteWorks/SubmitPageJSON',
    API_EMQ_LOADPAGEJSON: '/api/EMq/LoadPageJSON',
    API_EMQ_SUBMITPAGEJSON: '/api/EMq/SubmitPageJSON',
    API_EMR_LOADPAGEJSON: '/api/EMr/LoadPageJSON',
    API_EMR_SUBMITPAGEJSON: '/api/EMr/SubmitPageJSON',
    API_OMONITORINGNOTESUPPLY_LOADPAGEJSON: '/api/OMonitoringNoteSupply/LoadPageJSON',
    API_OMONITORINGNOTESUPPLY_SUBMITPAGEJSON: '/api/OMonitoringNoteSupply/SubmitPageJSON',
    API_OMONITORINGNOTEWORKS_LOADPAGEJSON: '/api/OMonitoringNoteWorks/LoadPageJSON',
    API_OMONITORINGNOTEWORKS_SUBMITPAGEJSON: '/api/OMonitoringNoteWorks/SubmitPageJSON',
    API_OMQ_LOADPAGEJSON: '/api/OMq/LoadPageJSON',
    API_OMQ_SUBMITPAGEJSON: '/api/OMq/SubmitPageJSON',
    API_OMR_LOADPAGEJSON: '/api/OMr/LoadPageJSON',
    API_OMR_SUBMITPAGEJSON: '/api/OMr/SubmitPageJSON',
    API_PROJECTDETAILS_GETLISTOFALLPROJECTS: '/api/ProjectDetails/GetListOfAllProjects',
    API_PROJECTDETAILS_GETLISTOFACTIVEMISSIONEDPROJECTS: '/api/ProjectDetails/GetListOfActiveMissionedProjects',
    API_PROJECTDETAILS_GETLISTOFMISSIONS: '/api/ProjectDetails/GetListOfMissions',
    API_PROJECTDETAILS_GETLISTOFALLMISSIONS: '/api/ProjectDetails/GetListOfAllMissions',
    API_PROJECTDETAILS_GETLISTOFMISSIONSBYROMTYPE: '/api/ProjectDetails/GetListOfMissionsByROMType',
    API_PROJECTDETAILS_GETLISTOFSAVEDANDFINISHEDMISSIONSBYROMTYPE: '/api/ProjectDetails/GetListOfSavedAndFinishedMissionsByROMType',
    API_PROJECTDETAILS_GETLISTOFMISSIONSBYROMTYPEFILTERBYDATE: '/api/ProjectDetails/GetListOfMissionsByROMTypeFilterByDate',
    API_PROJECTDETAILS_GETLISTOFSAVEDANDFINISHEDMISSIONSBYROMTYPEFILTERBYDATE: '/api/ProjectDetails/GetListOfSavedAndFinishedMissionsByROMTypeFilterByDate',
    API_PROJECTDETAILS_GETDETAILS: '/api/ProjectDetails/GetDetails',
    API_PROJECTDETAILS_ADDCOMPONENT: '/api/ProjectDetails/AddComponent',
    API_PROJECTDETAILS_GETCOMPONENTS: '/api/ProjectDetails/GetComponents',
    API_PROJECTDETAILS_REMOVECOMPONENT: '/api/ProjectDetails/RemoveComponent',
    API_PROJECTDETAILS_GETTYPEOFROM: '/api/ProjectDetails/GettypeOfROM',
    API_PROJECTDETAILS_GETMISSIONTEMPLATESTATUS: '/api/ProjectDetails/GetMissionTemplateStatus',
    API_PROJECTDETAILS_SETMISSIONTEMPLATEFINISHED: '/api/ProjectDetails/SetMissionTemplateFinished',
    API_PROJECTDETAILS_CHANGEPROJECTIDOFMISSION: '/api/ProjectDetails/ChangeProjectIdOfMission',
    API_PROJECTDETAILS_RESETMISSIONDETAILS: '/api/ProjectDetails/ResetMissionDetails',
    API_ASSIGNMISSION_USERS: '/api/AssignMission/AssignMissionUsers',
    API_ASSIGNMISSION_MON: '/api/AssignMission/AssignMissionMON',
    API_ASSIGNMISSION_QC: '/api/AssignMission/AssignMissionQC',
    API_ASSIGNMISSION_QA: '/api/AssignMission/AssignMissionQA',
    API_ASSIGNMISSION_STAKEHOLDERS_ADD: '/api/AssignMission/AssignMissionAddStakeholders',
    API_ASSIGNMISSION_STAKEHOLDERS_REMOVE: '/api/AssignMission/AssignMissionRemoveStakeholders',
    API_ASSIGNMISSION_LOADPAGE_STAKEHOLDERS: '/api/AssignMission/LoadPageStakeholders',
    API_ASSIGNMISSION_LOADPAGE_USERS: '/api/AssignMission/LoadPageUsers',
    API_ASSIGNMISSION_LOADPAGE_MONQCQADETAILS: '/api/AssignMission/LoadPageMONQCQADetails',
    API_ASSIGNMISSION_LOADPAGE_GETUSERSROLEFORMISSON: '/api/AssignMission/GetUsersRoleForMission',
    API_ASSIGNMISSION_LOADPAGE_GETLISTOFUSERSANDROLEFORMISSON: '/api/AssignMission/GetListOfUsersAndRoleForMission',
    API_CHECKLOGIN: '/api/AuthAPI/Login',
    API_CHECKTOKEN: '/api/AuthAPI/TokenAuth',
    API_REPORTCYCLE_SENDREVISION: '/api/ReportCycle/SendRevision',
    API_REPORTCYCLE_SENDQCREVISIONWITHEDITANDAPPROVE: '/api/ReportCycle/SendQCRevisionWithEditAndApprove',
    API_REPORTCYCLE_GETREVISION: '/api/ReportCycle/GetRevision',
    API_REPORTCYCLE_GETLASTREVISION: '/api/ReportCycle/GetLastRevision',
    API_REPORTCYCLE_APPROVEDRAFT: '/api/ReportCycle/ApproveDraft',
    API_REPORTCYCLE_APPROVEDRAFTPASTCYCLE: '/api/ReportCycle/ApproveDraftPastCycle',
    API_REPORTCYCLE_PREAPPROVELASTCHECKSENDEMAIL: '/api/ReportCycle/PreApproveLastCheckSendEmail',
    API_REPORTCYCLE_EXTENDDEADLINE: '/api/ReportCycle/ExtendDeadline',
    API_TEMPLATEFILLER_FILLANSWERS: '/api/TemplateFiller/FillAnswers',
    API_TEMPLATEFILLER_GETANSWERS: '/api/TemplateFiller/GetAnswers',
    API_UPLOADFILESPAGE_UPLOADFREEFORMFILES: '/api/UploadFilesPage/UploadFreeFormFiles',
    API_UPLOADFILESPAGE_GETFREEFORMONLYFILES: '/api/UploadFilesPage/GetFreeFormOnlyFiles',
    API_UPLOADFILESPAGE_GETFREEFORMWITHPROJECTFILES: '/api/UploadFilesPage/GetFreeFormWithProjectFiles',
    API_UPLOADFILESPAGE_DELETEPROJECTFILES: '/api/UploadFilesPage/DeleteProjectFiles',
    API_UPLOADFILESPAGE_DELETENONPROJECTFREEFORMFILES: '/api/UploadFilesPage/DeleteNonProjectFreeFormFiles',
    API_SEARCHFILTER_GETPAGELOADDATA: '/api/SearchFilter/GetPageLoadData',
    API_SEARCHFILTER_ACTIONSEARCHANDFILTER: '/api/SearchFilter/SearchAndFilter',
    API_SEARCHFILTER_CALCULATESCORE: '/api/SearchFilter/CalculateScore',
    API_USEROPERATIONS_LOADALLUSERS: '/api/UserOperations/LoadAllUsers',
    API_USEROPERATIONS_LOADACTIVEUSERS: '/api/UserOperations/LoadActiveUsers',
    API_USEROPERATIONS_CREATEUSER: '/api/UserOperations/CreateUser',
    API_USEROPERATIONS_UPDATEUSER: '/api/UserOperations/UpdateUser',
    API_USEROPERATIONS_GETUSERTYPE: '/api/UserOperations/GetUserType',
    API_USEROPERATIONS_GETUSERROLE: '/api/UserOperations/GetUserRole',
    API_USEROPERATIONS_PASSWORDCHANGE: '/api/UserOperations/PasswordChange',
    API_USEROPERATIONS_PASSWORDRESET: '/api/UserOperations/PasswordReset',
    API_USEROPERATIONS_LOADALLCONTACTLIST: '/api/UserOperations/LoadAllContactList',
    API_USEROPERATIONS_LOADACTIVECONTACTLIST: '/api/UserOperations/LoadActiveContactList',
    API_USEROPERATIONS_CREATECONTACTLISTITEM: '/api/UserOperations/CreateContactListItem',
    API_USEROPERATIONS_UPDATECONTACTLISTITEM: '/api/UserOperations/UpdateContactListItem',
    API_USEROPERATIONS_FORGOTPASSWORD: '/api/UserOperations/SendForgotPasswordResetLink',
    API_FILEUPLOADDOWNLOAD_DOWNLOADTEMPLATEWITHAUTOFILL: '/api/FileUploadDownload/DownloadTemplateWithAutofill',
    API_FILEUPLOADDOWNLOAD_GENERATEMONITORINGREPORTTEMPLATE: '/api/FileUploadDownload/GenerateMonitoringReportTemplate',
    API_FILEUPLOADDOWNLOAD_DOWNLOADMONITORINGREPORTTEMPLATE: '/api/FileUploadDownload/DownloadMonitoringReportTemplate',
    API_FILEUPLOADDOWNLOAD_DOWNLOADSTATICFILE: '/api/FileUploadDownload/DownloadStaticFile',
    API_FILEUPLOADDOWNLOAD_DOWNLOADTHEMATICREPORTTEMPLATE: '/api/FileUploadDownload/DownloadThematicReportTemplate',
    API_FILEUPLOADDOWNLOAD_LISTREVISIONFILEDETAILS: '/api/FileUploadDownload/ListRevisionFileDetails',
    API_FILEUPLOADDOWNLOAD_UPLOADRSFILEANDUPDATEREVISIONID: '/api/FileUploadDownload/UploadRSFileAndUpdateRevisionId',
    API_REPORTGENERATOR_GENERATETHEMATICREPORT: '/api/ReportGenerator/GenerateThematicReport',
    API_REPORTGENERATOR_EXPORTTHEMATICREPORT: '/api/ReportGenerator/ExportThematicReport',
    API_DEFINITIONS_GETLISTOFBENEFICIARIES: '/api/Definitions/GetListOfBeneficiaries',
    API_DEFINITIONS_CREATEBENEFICIARY: '/api/Definitions/CreateBeneficiary',
    API_DEFINITIONS_UPDATEBENEFICIARY: '/api/Definitions/UpdateBeneficiary',
};

export default class App extends Component {
    static displayName = App.name;

    //componentWillMount() {
    //	store.initializeStores()
    //}

    render() {
        return (
            <Provider {...stores}>
                <Router>
                    <Switch>
                        <Route path="/signin" component={SignInPage} />
                        <Route path="/login" component={SignInPage} />
                        <Route path="/passwordreset/:randomtoken" component={PasswordReset} />
                        <Route exact path="/" component={SignInPage} />
                        <Route path="/forgotpassword" component={ForgotPassword} />

                        {
                            //<Route
                            //    exact
                            //    path="/"
                            //    render={props => (
                            //        <Layout
                            //            {...props}
                            //            component={ProjectTable}
                            //            title="Project List"
                            //        />
                            //    )}
                            ///>
                        }
                        {
                            //<Route
                            //    path="/dashboard"
                            //    render={props => (
                            //        <Layout
                            //            {...props}
                            //            component={DashboardPage}
                            //            title="Dashboard"
                            //        />
                            //    )}
                            ///>
                        }
                        <Route
                            path="/dashboard"
                            render={props => (
                                <Layout
                                    {...props}
                                    component={ProjectTable}
                                    title=""
                                />
                            )}
                        />
                        <Route
                            path="/templatefilling/:id"
                            render={props => (
                                <Layout
                                    {...props}
                                    component={TemplateFillingPage}
                                    title="ROM Review Outputs"
                                />
                            )}
                        />
                        <Route
                            path="/projectlist"
                            render={props => (
                                <Layout
                                    {...props}
                                    component={ProjectTable}
                                    title=""
                                />
                            )}
                        />
                        {
                            //<Route
                            //    path="/missionlist"
                            //    render={props => (
                            //        <Layout
                            //            {...props}
                            //            component={MissionTable}
                            //            title="Mission List"
                            //        />
                            //    )}
                            ///>
                        }
                        <Route
                            path="/missionlist/:projectid"
                            render={props => (
                                <Layout
                                    {...props}
                                    component={MissionTable}
                                    title="Mission List"
                                />
                            )}
                        />
                        <Route
                            path="/createproject"
                            render={props => (
                                <Layout
                                    {...props}
                                    component={CreateProjectPage}
                                    title="Create Project"
                                />
                            )}
                        />
                        <Route
                            path="/createmission"
                            render={props => (
                                <Layout
                                    {...props}
                                    component={CreateMissionPage}
                                    title="Create Mission"
                                />
                            )}
                        />
                        <Route
                            path="/projectdetails/:id"
                            render={props => (
                                <Layout
                                    {...props}
                                    component={ProjectDetailsPage}
                                    title="Project Details"
                                />
                            )}
                        />
                        <Route
                            path="/missiondetails/:id"
                            render={props => (
                                <Layout
                                    {...props}
                                    component={MissionDetailsPage}
                                    title="Mission Details"
                                />
                            )}
                        />
                        <Route
                            path="/listofallprojects"
                            render={props => (
                                <Layout
                                    {...props}
                                    component={ListofAllProjects}
                                    title="List of All Projects"
                                />
                            )}
                        />
                        <Route
                            path="/cycleofthereport/:id"
                            render={props => (
                                <Layout
                                    {...props}
                                    component={CycleOfTheReportPage}
                                    title="ROM Report Cycle"
                                />
                            )}
                        />
                        <Route
                            path="/cycleofthereport2"
                            render={props => (
                                <Layout
                                    {...props}
                                    component={CycleOfTheReport2Page}
                                    title="Cycle Of The Report-2"
                                />
                            )}
                        />
                        <Route
                            path="/assignmission"
                            render={props => (
                                <Layout
                                    {...props}
                                    component={AssignMissionPage}
                                    title="Assign Mission"
                                />
                            )}
                        />
                        <Route
                            path="/uploadfile"
                            render={props => (
                                <Layout
                                    {...props}
                                    component={UploadFilePage}
                                    title="Library"
                                />
                            )}
                        />
                        <Route
                            path="/templatemonitoringnotesupply"
                            render={props => (
                                <Layout
                                    {...props}
                                    component={E_MonitoringNoteSupply}
                                    title="Template Monitoring Note for Supply"
                                />
                            )}
                        />
                        <Route
                            path="/templatemonitoringnoteworks"
                            render={props => (
                                <Layout
                                    {...props}
                                    component={E_MonitoringNoteWorks}
                                    title="Template Monitoring Note for Works"
                                />
                            )}
                        />
                        <Route
                            path="/templatemq"
                            render={props => (
                                <Layout {...props} component={E_Mq} title="Template MQ " />
                            )}
                        />
                        <Route
                            path="/templatemr"
                            render={props => (
                                <Layout {...props} component={E_Mr} title="Template MR" />
                            )}
                        />
                        <Route
                            path="/templatemonitoringnotesuppliesongoing"
                            render={props => (
                                <Layout
                                    {...props}
                                    component={O_MonitoringNoteSupplies}
                                    title="Template Montaring Note Supplices Ongoing"
                                />
                            )}
                        />
                        <Route
                            path="/templatemonitoringnoteworksongoing"
                            render={props => (
                                <Layout
                                    {...props}
                                    component={O_MonitoringNoteWorks}
                                    title="Template Montaring Note Works Ongoing"
                                />
                            )}
                        />
                        <Route
                            path="/templatemrongoing"
                            render={props => (
                                <Layout
                                    {...props}
                                    component={O_Mr}
                                    title="Template MR Ongoing "
                                />
                            )}
                        />
                        <Route
                            path="/templatemqongoing"
                            render={props => (
                                <Layout
                                    {...props}
                                    component={O_Mq}
                                    title="Template MQ Ongoing "
                                />
                            )}
                        />
                        <Route
                            path="/searchfilter"
                            render={props => (
                                <Layout
                                    {...props}
                                    //component={SearchFilter}
                                    component={props => <SearchFilter {...props} />}
                                    title="Search And Report "
                                />
                            )}
                        />
                        <Route
                            path="/users"
                            render={props => (
                                <Layout
                                    {...props}
                                    component={UsersPage}
                                    title="Users"
                                />
                            )}
                        />
                        <Route
                            path="/contactlist"
                            render={props => (
                                <Layout
                                    {...props}
                                    component={ContactListPage}
                                    title="Contact List"
                                />
                            )}
                        />
                        <Route
                            path="/changepassword"
                            render={props => (
                                <Layout
                                    {...props}
                                    component={ChangePasswordPage}
                                    title="Password Change"
                                />
                            )}
                        />
                        <Route
                            path="/thematicreport"
                            render={props => (
                                <Layout
                                    {...props}
                                    //component={ThematicReport}
                                    component={props => <ThematicReport {...props} />}
                                    title="Segment Report"
                                />
                            )}
                        />
                        <Route
                            path="/createmissionpageauthorized"
                            render={props => (
                                <Layout
                                    {...props}
                                    component={CreateMissionPageAuthorized}
                                    title="Upload Full Cycle"
                                />
                            )}
                        />
                        <Route
                            path="/beneficiaries"
                            render={props => (
                                <Layout
                                    {...props}
                                    component={DefinitionsBeneficiariesPage}
                                    title="Beneficiaries"
                                />
                            )}
                        />
                        <Route
                            path="/help"
                            render={props => (
                                <Layout
                                    {...props}
                                    component={HelpPage}
                                    title="Help"
                                />
                            )}
                        />
                        <Route
                            path="/entryintervention"
                            render={props => (
                                <Layout
                                    {...props}
                                    component={EntryIntervention}
                                    title="Entries"
                                />
                            )}
                        />
                    </Switch>
                </Router>
            </Provider>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App.js